const aiEight = [

  {
      "name": "NightCafe",
      "url": "https://creator.nightcafe.studio/",
      icon: "images/night-cafe-1.png",
      "description": "AI绘画工具，提供多种绘画风格和参数设置，帮助用户生成独特艺术作品。",
      isVpn: true
  },
  {
      "name": "midjourney",
      "url": "https://www.midjourney.com/home",
      icon: "images/midjourney.png",
      "description": "专注AI绘画与图像生成的在线平台，提供丰富工具和素材，助力用户实现创作。"
  },
  {
      "name": "fotor",
      "url": "https://www.fotor.com/",
      icon: "images/fotor.png",
      "description": "集图片编辑、设计、拼图于一体的在线工具，提供多种滤镜和特效。"
  },
  {
      "name": "Scribble Diffusion",
      "url": "https://scribblediffusion.com/",
      icon: "images/scribble.jpg",
      "description": "基于AI的绘画工具，提供多种绘画模式和风格，快速生成高质量艺术作品。",
      isVpn: true
  },
  {
      "name": "BoothAI",
      "url": "https://www.atom.com/name/Booth.ai",
      "icon": "images/Booth.png",
      "description": "专注AI图像生成的在线工具，提供多场景、多风格的图像生成服务。"
  },
  {
      "name": "Draw Things",
      "url": "https://drawthings.ai/",
      icon: "images/draw-things.png",
      "description": "简单易用的AI绘画工具，提供多种绘画风格和素材，适合初学者。"
  },
  {
      "name": "Glazeroom",
      "url": "https://glazeroom.com/",
      icon: "images/glazeroom.png",
      "description": "提供AI图像生成和编辑服务，支持多种格式和分辨率。"
  },
  {
      "name": "Astria",
      "url": "https://www.astria.ai/",
      icon: "images/astria.png",
      "description": "专注AI艺术创作的在线工具，提供丰富艺术风格和素材库。"
  },
  {
      "name": "Lexica",
      "url": "https://lexica.art/",
      icon: "images/lexica.png",
      "description": "基于AI的艺术创作平台，提供多种艺术风格和创作工具。",
      isVpn: true
  },
  {
      "name": "RestorePhotos",
      "url": "https://www.restorephotos.io/",
      icon: "images/restorephotos.png",
      "description": "专注老照片修复和图像增强，利用AI技术提升照片质量。"
  },
  {
      "name": "AI Image Enlarger",
      "url": "https://cn.imglarger.com/",
      icon: "images/ai-image.jpg",
      "description": "利用AI技术无损放大图片，支持多种格式和分辨率。"
  },
  {
      "name": "Watermark Remover",
      "url": "https://www.watermarkremover.io/",
      icon: "images/Watermark-Remover.png",
      "description": "专注去除图片水印，利用AI智能识别并去除水印。"
  },
  {
      "name": "ThisPersonDoesNotExist",
      "url": "https://www.thispersondoesnotexist.com/",
      icon: "images/ThisPersonDoesNotExist.jpg",
      "description": "利用AI生成虚拟人脸，提供多种参数和风格选择。"
  },
  {
      "name": "Shrink media",
      "url": "https://www.shrink.media/",
      icon: "images/shrink.png",
      "description": "专注图像压缩的在线工具，利用智能技术减小图片尺寸。"
  },
  {
      "name": "photosonic",
      "url": "https://photosonic.writesonic.com/",
      icon: "images/photosonic.png",
      "description": "智能AI艺术作品生成器，根据用户描述生成艺术作品。"
  },
  {
      "name": "Arthub.ai",
      "url": "https://arthub.ai/",
      icon: "images/arthub.jpg",
      "description": "专注AI艺术创作的在线平台，提供多种艺术风格和创作工具。",
      isVpn: true
  },
  {
      "name": "Maze Guru",
      "url": "",
      icon: "images/",
      "description": "利用AI技术解决迷宫问题的在线工具。"
  },
  {
      "name": "Craiyon",
      "url": "",
      icon: "images/",
      "description": "专注AI图像生成的在线工具，提供多场景、多风格图像生成服务。"
  },
  {
      "name": "Magic Eraser",
      "url": "https://magicstudio.com/zh/magiceraser/",
      icon: "images/Magic-Eraser.png",
      "description": "利用AI技术去除图片中不需要元素的在线工具。"
  },
  {
      "name": "This Beach Does Not Exist",
      "url": "https://thisbeachdoesnotexist.com/",
      icon: "images/this-beach-does-not.jpg",
      "description": "利用AI技术生成虚拟海滩场景的在线工具。",
      isVpn: true
  },
  {
      "name": "Let's Enhance",
      "url": "https://letsenhance.io/zh-CN/",
      icon: "images/Lets-Enhance.jpg",
      "description": "专注图像增强的在线工具，利用AI技术提升图片质量。"
  },
  {
      "name": "Leonardo",
      "url": "https://leonardo.ai/",
      icon: "images/leonardo.png",
      "description": "专注AI艺术创作的在线工具，提供丰富艺术风格和素材库。",
      isVpn: true
  },
  {
      "name": "AISEO ART",
      "url": "https://art.aiseo.ai/",
      icon: "images/AISEO.png",
      "description": "专注AI艺术创作的在线平台，提供多种艺术风格和创作工具。",
      isVpn: true
  },
  {
      "name": "海艺AI",
      "url": "https://seaart.ai/home?&ad=070220",
      icon: "images/haiyi.png",
      "description": "专注AI艺术创作的在线工具，提供丰富艺术风格和素材库。"
  },
  {
      "name": "天才助理",
      "url": "https://2gpt.ai/?shareKey=RIM3N34I",
      icon: "images/tian-cai-zhuli.png",
      "description": "利用AI技术提供创作灵感的在线工具。"
  },
  {
      "name": "小冰智能",
      "url": "https://ai.ainvp.com/home",
      icon: "images/xiaobing.png",
      "description": "专注AI图像生成和对话的在线平台。"
  },
  {
      "name": "文心一格",
      "url": "https://yige.baidu.com/",
      icon: "images/wxyg.jpeg",
      "description": "百度 AI 产品，创意和艺术辅助产品。"
  },
  {
      "name": "一览运营宝",
      "url": "https://yyb.yilantv.com/vam/",
      icon: "images/yilan.jpg",
      "description": "专注社交媒体运营，提供运营策略和数据分析服务。"
  },
  {
      "name": "美图设计室",
      "url": "https://www.designkit.com/?channel=jyshare",
      icon: "images/meitushejishi.png",
      "description": "集图片编辑和设计于一体的在线工具。"
  },
  {
      "name": "whee",
      "url": "https://www.whee.com/",
      icon: "images/whee.jpg",
      "description": "利用AI技术提供创作灵感的在线工具。"
  },
  {
      "name": "Civitai",
      "url": "https://civitai.com/",
      icon: "images/civitai-icon-filled-36.png",
      "description": "专注AI艺术创作的在线社区，提供多种艺术风格和创作工具。"
  },
  {
      "name": "Vega AI",
      "url": "https://www.vegaai.net/",
      icon: "images/vega.jpg",
      "description": "专注AI图像生成的在线工具，提供多场景、多风格图像生成服务。",
      isVpn: true
  },
  {
      "name": "Yodayo",
      "url": "http://yodayo.com/",
      icon: "images/yodayo.jpg",
      "description": "利用AI技术提供个性化推荐的在线工具。",
      isVpn: true
  },
  {
      "name": "Picsart",
      "url": "https://picsart.com",
      icon: "images/piczart.jpg",
      "description": "集图片编辑、设计和拼图于一体的在线工具，功能丰富易用。",
      isVpn: true
  },
  {
      "name": "Sea Art AI",
      "url": "http://seaart.ai/",
      icon: "images/seaart.png",
      "description": "专注AI艺术创作的在线平台，提供多种艺术风格和创作工具。",
      isVpn: true
  },
  {
      "name": "PixAI",
      "url": "http://www.pixai.art/",
      icon: "images/pixai.jpg",
      "description": "提供AI图像识别和编辑服务的在线工具。",
      isVpn: true
  },
  {
      "name": "Ideogram",
      "url": "http://www.ideogram.ai/",
      icon: "images/ideogram.png",
      "description": "利用AI技术生成图表和图形的在线工具。",
      isVpn: true
  },
  {
      "name": "Pixelcut",
      "url": "https://www.pixelcut.ai/",
      icon: "images/pixelcut.png",
      "description": "专注图像切割和编辑的在线工具。",
      isVpn: true
  },
  {
      "name": "Krea",
      "url": "http://www.krea.ai/",
      icon: "images/krea.png",
      "description": "利用AI技术提供创作灵感的在线工具。",
      isVpn: true
  },
  {
      "name": "Undress AI",
      "url": "https://undress.app/",
      icon: "images/undress.jpg",
      "description": "利用AI技术去除图片中衣物的在线工具（注：此类工具可能涉及伦理和隐私问题，使用时需谨慎）。"
  },
  {
      "name": "Cleanup Pictures",
      "url": "https://cleanup.pictures/",
      icon: "images/cleanup-pictures.png",
      "description": "专注图片清理和优化的在线工具。"
  },
  {
      "name": "Cutout Pro",
      "url": "https://www.cutout.pro/",
      icon: "images/cutout.jpg",
      "description": "专注图像抠图和背景去除的在线工具。",
      isVpn: true
  },
  {
      "name": "易可图",
      "url": "https://www.yiketu.com/",
      icon: "images/yiketu.png",
      "description": "集图片编辑和设计于一体的在线工具。"
  },
  {
      "name": "绘蛙",
      "url": "https://www.ihuiwa.com/",
      icon: "images/huiwa.png",
      "description": "利用AI技术提供绘画灵感的在线工具。"
  },
  {
      "name": "即梦AI",
      "url": "https://jimeng.jianying.com/",
      icon: "images/jmeng.jpg",
      "description": "专注AI艺术创作的在线工具，提供丰富艺术风格和素材库。"
  },
  {
      "name": "标小智LOGO",
      "url": "https://www.logosc.cn/",
      icon: "images/biaoxiaozhi.jpg",
      "description": "利用AI技术生成LOGO的在线工具。"
  },
  {
      "name": "iColoring AI",
      "url": "https://icoloring.ai/",
      icon: "images/iColoring-AI-1.png",
      "description": "利用AI技术提供涂色灵感的在线工具。"
  },
  {
      "name": "可灵AI",
      "url": "https://app.klingai.com/cn/",
      icon: "images/keling.png",
      "description": "专注AI图像生成和对话的在线平台。"
  },
  {
      "name": "Comfy",
      "url": "https://www.comfy.org/zh-cn/",
      icon: "images/comfy.png",
      "description": "利用AI技术提供创作灵感的在线工具。"
  },
  {
      "name": "LiblibAI",
      "url": "https://www.liblib.art/",
      icon: "images/liblib.png",
      "description": "专注AI艺术创作的在线平台，提供多种艺术风格和创作工具。"
  },
  {
      "name": "FLUX",
      "url": "https://www.flux.ai/p",
      icon: "images/FLUX.png",
      "description": "利用AI技术提供个性化推荐的在线工具。"
  },
  {
      "name": "无界版图",
      "url": "https://www.wujieai.com/",
      icon: "images/wujiebantu.jpg",
      "description": "专注AI艺术创作的在线平台，提供多种艺术风格和创作工具。"
  },
  {
      "name": "Skybox AI",
      "url": "https://skybox.blockadelabs.com/",
      icon: "images/Skybox-AI.png",
      "description": "利用AI技术生成3D图像的在线工具。",
      isVpn: true
  },
  // {
  //     "name": "美图抠图",
  //     "url": "",
  //     icon: "images/",
  //     "description": "专注图像抠图和背景去除的在线工具。"
  // },
  {
      "name": "一键抠图",
      "url": "https://www.yijiankoutu.com/",
      icon: "images/yijiankoutu.png",
      "description": "简单易用的图像抠图工具，支持多种抠图模式。"
  },
  {
      "name": "Relight",
      "url": "https://clipdrop.co/relight",
      icon: "images/relight.png",
      "description": "利用AI技术调整图片光照效果的在线工具。"
  },
  {
      "name": "美图云修",
      "url": "https://yunxiu.meitu.com/home",
      icon: "images/meituyunxiu.png",
      "description": "集图片编辑和修复于一体的在线工具。"
  },
  {
      "name": "HD jpgHD",
      "url": "https://jpghd.com/zh",
      icon: "images/jpgHD.png",
      "description": "专注图片高清化和修复的在线工具。"
  },
  // {
  //     "name": "Hama",
  //     "url": "",
  //     icon: "images/",
  //     "description": "利用AI技术提供创作灵感的在线工具。"
  // }
]

export default aiEight
